(() => {
  const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const addBusinessDays = (date, days) => {
    const result = new Date(date);
    let remaining = days;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) remaining -= 1;
    }
    return result;
  };

  const formatDate = (date, months) => `${months[date.getMonth()]} ${date.getDate()}`;
  const formatRange = (start, end, months) => {
    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
      return `${months[start.getMonth()]} ${start.getDate()}–${end.getDate()}`;
    }
    return `${formatDate(start, months)}–${formatDate(end, months)}`;
  };

  const close = (summary, returnFocus = false) => {
    const toggle = summary.querySelector('[data-hc-delivery-toggle]');
    const panel = summary.querySelector('[data-hc-delivery-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    if (returnFocus) toggle.focus();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-hc-delivery-summary]:not([data-hc-delivery-ready]), [data-hc-delivery-timeline]:not([data-hc-delivery-ready])').forEach((summary) => {
      summary.setAttribute('data-hc-delivery-ready', 'true');

      const processingMin = Math.max(0, Number.parseInt(summary.dataset.processingMin, 10) || 2);
      const processingMax = Math.max(0, Number.parseInt(summary.dataset.processingMax, 10) || 5);
      const deliveryMin = Math.max(0, Number.parseInt(summary.dataset.deliveryMin, 10) || 7);
      const deliveryMax = Math.max(0, Number.parseInt(summary.dataset.deliveryMax, 10) || 12);
      const today = new Date();
      today.setHours(12, 0, 0, 0);

      const shipStart = addBusinessDays(today, Math.min(processingMin, processingMax));
      const shipEnd = addBusinessDays(today, Math.max(processingMin, processingMax));
      const deliveredStart = addBusinessDays(shipStart, Math.min(deliveryMin, deliveryMax));
      const deliveredEnd = addBusinessDays(shipEnd, Math.max(deliveryMin, deliveryMax));
      const deliveryRange = formatRange(deliveredStart, deliveredEnd, shortMonths);

      const rangeLabel = summary.querySelector('[data-hc-delivery-range]');
      if (rangeLabel) rangeLabel.textContent = deliveryRange;
      summary.querySelector('[data-hc-order-placed]').textContent = formatDate(today, longMonths);
      summary.querySelector('[data-hc-order-ships]').textContent = formatRange(shipStart, shipEnd, longMonths);
      summary.querySelector('[data-hc-order-delivered]').textContent = deliveryRange;

      const toggle = summary.querySelector('[data-hc-delivery-toggle]');
      const panel = summary.querySelector('[data-hc-delivery-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', () => {
        const willOpen = panel.hidden;
        document.querySelectorAll('[data-hc-delivery-summary]').forEach((other) => {
          if (other !== summary) close(other);
        });
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
      });

      summary.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          close(summary, true);
        }
      });
    });
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-hc-delivery-summary]').forEach((summary) => {
      if (!summary.contains(event.target)) close(summary);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.HcDeliverySummary = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
